// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { createLinkIconStyles } from "@keller/XDL/Utilities";
import { modalButtonsActionStyles } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

addToListModalStyles.modal = {
    sizeVariant: "medium",
};

addToListModalStyles.editingPermissionRadioGroup = {
    horizontal: true,
};

addToListModalStyles.userRemoveLink = {
    ...createLinkIconStyles("X"),
    css: css`
        margin-left: 20px;
    `,
};

addToListModalStyles.buttonsWrapper = {
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        margin-top: 25px;
    `,
};
addToListModalStyles.makePrivateButton = modalButtonsActionStyles.cancelButton;

addToListModalStyles.closeButton = modalButtonsActionStyles.submitButton;

addToListModalStyles.usersTableWrapper = {
    css: css`
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        & > * {
            margin-top: 20px;
        }
    `,
};

addToListModalStyles.userCell = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};
